export const EmployeeContractVI = {
    "EmployeeContractAdd": {
        "EmployeeContractAdd": "Thêm hợp đồng",
        "EmployeeContractEdit": "Cập nhật hợp đồng",
        "EmployeeContractDelete": "Xoá hợp đồng",
        "ListEmployeeContract": "Danh sách hợp đồng",
        "LiquidationEmployeeContract": "Thanh lý hợp đồng",
        "ApprovalEmployeeContract": "Duyệt hợp đồng ",
        "QuickView": "Xem nhanh ",
        "undoApproval": "Hoàn duyệt "
    },
    "EmployeeContractTitle": {
        "employeeContractId": "Mã HĐ",
        "fullName": "Họ và tên",
        "CurrentDepartment": "Phòng Ban ",
        "signDay": "Ngày Ký",
        "effectiveDate": "Hiệu lực từ ngày",
        "tillDate": "Đến ngày ",
        "Status": "Trạng thái ",
        "StatusQuo": "Tình trạng",
        "creator": "Người tạo ",
        "creatdate": "Ngày tạo ",
        "employeeId": " Nhân viên ",
        "contractId": "Loại hợp đồng ",
        "form": " Hình thức làm việc ",
        "position": " Vị trí",
        "office": " Chức vụ",
        "workplace": " Nơi làm việc",
        "signerId": "Người ký",
        "FIle": "Đính kèm ",
        "glone": "Ngạch lương",
        "to": " Đến ",
        "description": "Ghi chú",
        "informationSalary": "Thông tin lương và phụ cấp",
        "informationGeneral": "Thông tin chung",
        "notFound": "không có thông tin lương và phụ cấp",
        "approved": "Đã duyệt",
        "liquidated": " Thanh lý",
        "pending": "Chờ duyệt",
        "end": "Kết thúc",
        "Unsigned": "Chưa ký",
        "ineffect": "Đang hiệu lực",
        "expired": "Hết hiệu lực",
        "notyetvalid": "Chưa hiệu lực ",
        "liquidation": "Thanh lý ",
        "status": "Trạng thái",
        "contractName": "Tên hợp đồng",
        "jobDetails": "Công việc",
        "Working": "Đang làm việc",
        "Waiting": "Chờ nhân việc",
        "DropTemp": "Nghỉ tạm thời ",
        "Resignation": "Nghỉ việc"
    },
    "placeholderEMC": {
        "employeeContractId": "Mã HĐ",
        "fullName": "Tên nhân viên",
        "CurrentDepartment": "Phòng ban ",
        "signDay": "Ngày ký",
        "effectiveDate": "Hiệu lực từ ngày",
        "tillDate": "Đến ngày ",
        "Status": "Trạng thái ",
        "creator": "Người tạo ",
        "creatdate": "Ngày tạo ",
        "employeeId": "Tìm với mã ,họ tên",
        "contractId": "Loại hợp đồng ",
        "form": "Hình thức",
        "position": " Vị trí",
        "office": " Chức vụ",
        "workplace": " Nơi làm việc",
        "signerId": "Tìm với mã ,họ tên, người ký",
        "FIle": "Đính kèm ",
        "signerDay": "Từ ngày ",
        "glone": "Ngạch lương",
        "since": "Từ ngày",
        "Note": "Ghi chú",
        "Salaryform": " Hình thức lương ",
        "Amountofmoney": " Số tiền ",
        "Allowance": "Phụ cấp"
    },
    "buttonEMC": {
        "buttonSubmit": "Tạo mới",
        "buttonUpdate": "Sửa",
        "buttonCancel": "Hủy Bỏ",
        "buttonKeep": "Giữ trang sau khi ",
        "buttonGo": "Chuyển đến danh sách sau khi ",
        "approve": "Duyệt",
        "agree": "Đồng ý"
    },
    "NotificationEmployeeContract": {
        "edit": "Sửa dữ liệu thành công",
        "add": "Thêm dữ liệu thành công",
        "delete": "Xóa dữ liệu thành công",
        "Liquidation": "Cập nhật trạng thái thành công",
        "question": " Bạn có muốn xóa không ? ",
        "questionApproval": "Bạn có muốn duyệt hợp đồng này không ? ",
        "approval": "Duyệt hợp đồng thành công",
        "titleApproval": "Duyệt hợp đồng",
        "effectiveToSingDay": "Ngày ký không được lớn hơn ngày kết thúc hợp đồng",
        "effectiveToSince": "Lương và các khoản phụ cấp kể từ ngày hợp đồng không được lớn hơn ngày chấm dứt hợp đồng",
        "effectiveFromSince": "Lương và phụ cấp kể từ ngày không được thấp hơn ngày bắt đầu hợp đồng",
        "effectiveFromEffectiveTo": "Ngày hết hạn hợp đồng nhân viên sau ngày có hiệu lực",
        "salaryError": "Hình thức lương của ngày ",
        "salaryError1": " không được trùng nhau ",
        "AllowanceError": "Loại phụ cấp của ngày ",
        "updateSuccess": "Đã cập nhật thành công",
        "startDate": "Ngày bắt đầu ( ",
        "notJoinDate": " ) không được nhỏ hơn Ngày bắt đầu làm việc ",
        "questionUndo": "Bạn có muốn hoàn duyệt không? ",
        "duplicateDate": "Không được nhập  trùng nhau"

    },
    "EmployeeContract": {
        "search": "Tìm kiếm hồ sơ",
        "myApproval": "Hợp đồng bạn duyệt",
        "noDataResponse": "Không có kết quả nào",
        "updateContract": "Cập nhật hợp đồng",
        "addContract": "Thêm mới hợp đồng",
        "add": "Thêm",
        "allContract": "Tất cả hợp đồng",
        "approvalContract": "Hợp đồng đang có hiệu lực",
        "noApprovalContract": "Hợp đồng hết hiệu lực",
        "oneYear": "Hợp đồng một năm",
        "threeYear": "Hợp đồng ba năm",
        "internship": "Hợp đồng thực tập",
        "noContract" : "Chưa có hợp đồng",
        "day" : "Ngày",
        "approval" : "Đang hiệu lực",
        "liquidation": "Hợp đồng thanh lý",

    },
    "EmployeeCareer": {
        "startDate": "Ngày bắt đầu",
        "department" : "Phòng ban",
        "jobPosition": "Vị trí",
        "jobTitle": "Chức vụ",
        "jobTitleRequired" : "Chức vụ là yêu cầu",
        "jobPositionRequired" : "Vị trí là yêu cầu",
        "departmentRequired" : "Phòng ban là yêu cầu",
        "startDateRequired" : "Ngày bắt đầu là yêu cầu",
        "sinceRequired" : "Từ ngày là yêu cầu",
        "since" : "Từ ngày",
        "deleteConcurrently" : "Xóa kiêm nhiệm của nhân sự",
        "deleteCareer" : "Xóa lịch sử công việc cập nhật trực tiếp của nhân sự",
        "createBy" : "Tạo bởi",
        "employeeContract": "Hợp đồng",
        "decisionTransfer": "QĐ điều chuyển",
        "decisionAdmission": "QĐ tiếp nhận",
        "decisionAppointment": "QĐ bổ nhiệm",
        "decisionDismissal": "QĐ miễn nhiệm",
        "decisionContract": "QĐ chấm dứt HĐ",
        "updatePosition": "Cập nhật trực tiếp vị trí",
        "questionConcurrently" : "Bạn có chắc chắn muốn xóa kiêm nhiệm này của nhân sự không?",
        "questionCareer" : "Bạn có chắc chắn muốn xóa vị trí trực tiếp này của nhân sự không?",
        "startDateSalaryRequired" : "Từ ngày là yêu cầu",
        "startDateSalary": "Từ ngày",
        "salaryForm": "Hình thức lương",
        "salaryFormRequired": "Hình thức lương là yêu cầu",
        "amountOfMoney": "Số tiền",
        "amountOfMoneyRequired": "Số tiền là yêu cầu",
        "allowance": "Phụ cấp",
        "allowanceRequired": "Phụ cấp là yêu cầu",
        "deleteSalaryAllowance" : "Xóa lương và phụ cấp của nhân sự",
        "questionSalaryAllowance" : "Bạn có chắc chắn muốn xóa lương và phụ cấp này của nhân sự không?",
        "startContract" : "Lịch sử tự động sinh ra từ ngày bắt đầu hợp đồng.",
        "endContract" : "Lịch sử tự động sinh ra từ ngày kết thúc hợp đồng.",
        "contractLiquidation" : "Lịch sử tự động sinh ra từ thanh lý hợp đồng.",
        "updatePositionJob" : "Lịch sử tự động sinh ra từ cập nhật trực tiếp.",
        "decisionContractTooltip" : "Lịch sử tự động sinh ra từ quyết định chấm dứt hợp đồng.",
        "decisionDismissalTooltip" : "Lịch sử tự động sinh ra từ quyết định miễn nhiệm.",
        "decisionAppointmentTooltip" : "Lịch sử tự động sinh ra từ quyết định bổ nhiệm.",
        "decisionAdmissionTooltip" : "Lịch sử tự động sinh ra từ quyết định tiếp nhận.",
        "decisionTransferTooltip" : "Lịch sử tự động sinh ra từ quyết định điều chuyển.",
        "salaryContract" : "Lịch sử tự động sinh ra từ hợp đồng.",
    }
}
